/* DOMNO. rewards — the FREE GIFT cart line, and the £25 guard.

   Copy is governed by Outputs/Rewards Portal/rewards-copy-deck.md.
   Banned everywhere: unlock, redeem, points, tier, member, VIP, exclusive, claim, loyalty.

   ⚠ THE TWO BUTTONS SAY DIFFERENT THINGS ON PURPOSE. Dom, 9 Sep: the home panel said "Choose
   yours" and the Rewards panel said "Choose your free ring", which read as the same button twice.
   The home one NAVIGATES, so it says where it goes — **View rewards** — and the choosing happens
   on the screen it takes you to. Do not make them match again.

   ⚠ THE BALANCE BOX IS NOT OURS. domno-portal-credits.js owns the one box at the top of Rewards
   and hides the drawer's duplicate .hero. This file must never write into either, or they fight.

   ⚠ THE THUMBNAIL IS NOT SWAPPED. The red FREE GIFT card stays on every cart line so it reads as
   a gift rather than another item they are buying. `_reward_img` is written but unused.

   ⚠ THE WORTH IS INJECTED, NOT REAL DATA. An earlier version gave FREE GIFT a compare-at price
   per rung so the theme drew a real strikethrough. Correct in GBP, wrong everywhere else: DOMNO.
   sets foreign prices per product and the ladder is not monotonic — in USD a £16 chain and a £20
   chain are both $35, while a £45 bracelet and a £25 ring are both $50.

   ⚠ EVERY PAINT MUST BE IDEMPOTENT. This runs off a MutationObserver, so an unconditional write
   is seen as a change, which paints again — an infinite loop that locks the tab. It has happened.
   Hence `writing` and the data-dp-state stamps. Guard anything new the same way. */
(function(){
  var PRODUCT = 15982353908085;

  function money(s){
    if (typeof window.dpMoney === 'function') return window.dpMoney(s);
    return s == null ? '' : String(s).replace(/<[^>]*>/g, '').trim();
  }
  function minSpend(){
    if (typeof window.dpMinSpend === 'function') return window.dpMinSpend();
    var h = document.getElementById('dp-rings');
    return money((h && h.getAttribute('data-minspend')) || '£25');
  }
  function esc(s){
    return String(s).replace(/[&<>"]/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c];
    });
  }
  /* every cart WRITE in the portal goes through one queue — see domno-portal-money.js */
  function queue(fn){
    return (typeof window.dpCartQueue === 'function') ? window.dpCartQueue(fn) : fn();
  }
  function rewardLines(cart){
    return (cart.items || []).filter(function(i){
      return i.product_id === PRODUCT || (i.properties && i.properties._reward_variant);
    });
  }
  function labelOf(line){
    var p = line.properties || {};
    for (var k in p){ if (k.charAt(0) !== '_' && p[k] === 'FREE') return k; }
    return '';
  }
  function partsOf(line){
    var p = line.properties || {};
    var label = labelOf(line);
    var name = p._reward_name || '', opts = p._reward_opts || '';
    if (!name && label){ var b = label.split(' · '); name = b.shift(); opts = b.join(' · '); }
    return { label: label, name: name || 'your free piece', opts: opts };
  }

  var writing = false;
  function write(fn){
    writing = true;
    try{ fn(); } catch(e){}
    setTimeout(function(){ writing = false; }, 0);
  }

  /* ---------- how far short are they? ----------
     items_subtotal_price is the sum of the lines after line discounts, the closest match to the
     currentSubtotalPriceSet the worker actually checks. The free piece is £0 so it never inflates
     its own threshold. Minor units, so /100. */
  var shortfall = null;
  function computeShortfall(cart){
    if (!rewardLines(cart).length) return null;
    var min = (typeof window.dpMinSpendValue === 'function') ? window.dpMinSpendValue() : null;
    if (min == null) return null;                 /* cannot tell — never block on a guess */
    var have = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price) / 100;
    return { short: have < min, need: Math.max(0, min - have), have: have, min: min };
  }

  /* ---------- the cart line ---------- */
  function paintLine(line){
    var p = line.properties || {};
    /* 14 Sep 2026 — looked up live rather than read off the frozen property, or it stays in
       pounds after a market switch. See dpWorthFor in domno-portal-money.js. */
    var worth = (typeof window.dpWorthFor === 'function')
      ? window.dpWorthFor(p._reward_variant, p._reward_worth)
      : money(p._reward_worth);
    var warn  = (shortfall && shortfall.short)
      ? (typeof window.dpFormat === 'function' ? window.dpFormat(shortfall.need) : '') : '';
    var stamp = worth + '|' + warn;

    var els = document.querySelectorAll('.cart-item.product-free-gift');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el.getAttribute('data-dp-state') === stamp) continue;
      (function(el, worth, warn, stamp){
        write(function(){
          if (worth){
            ['.cart-item__price', '.cart-item__total'].forEach(function(sel){
              var box = el.querySelector(sel);
              if (!box) return;
              var old = box.querySelector('.dp-worth');
              if (old) old.parentNode.removeChild(old);
              var s = document.createElement('span');
              s.className = 'struck-out-price small-text dp-worth';
              s.innerHTML = '<span class="theme-money">' + esc(worth) + '</span>';
              box.appendChild(s);
            });
          }
          var desc = el.querySelector('.cart-item__description .small-text') ||
                     el.querySelector('.cart-item__description');
          var old2 = el.querySelector('.dp-short');
          if (old2) old2.parentNode.removeChild(old2);
          if (warn && desc){
            var w = document.createElement('div');
            w.className = 'dp-short';
            w.textContent = warn + ' more and it’s yours';
            desc.appendChild(w);
          }
          el.setAttribute('data-dp-state', stamp);
        });
      })(el, worth, warn, stamp);
    }
  }

  /* One free piece means ONE. */
  var fixing = false;
  async function forceOne(line){
    if (fixing || line.quantity <= 1) return;
    fixing = true;
    try{
      await queue(function(){
        return fetch('/cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: line.key, quantity: 1 })
        });
      });
      location.reload();
    }catch(e){ fixing = false; }
  }

  /* ⚠ In the SIDE CART the theme hides .cart-item__remove entirely — the only way out of a drawer
     line is pressing minus at quantity 1, so hiding the stepper trapped the free gift with no way
     to remove it. CSS puts Remove back; this is the portal's own button.
     ⚠ It runs on the queue: it reads the cart then deletes every reward line it found, so if that
     READ landed after claim.js's ADD it would delete the piece just chosen. */
  window.dpRemoveGift = async function(){
    await queue(async function(){
      try{
        var cart = await (await fetch('/cart.js', { headers:{ 'Accept':'application/json' } })).json();
        var ls = rewardLines(cart);
        for (var i=0;i<ls.length;i++){
          await fetch('/cart/change.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ id: ls[i].key, quantity: 0 })
          });
        }
      }catch(e){}
    });
    ['on:cart:change','on:cart:after-merge','dispatch:cart-drawer:refresh'].forEach(function(nm){
      try{ document.dispatchEvent(new CustomEvent(nm,{bubbles:true})); }catch(e){}
    });
    try{ await refresh(); }catch(e){}
    try{ if (typeof window.dpCreditsRefresh === 'function') window.dpCreditsRefresh(); }catch(e){}
    if (/\/cart/.test(location.pathname)) location.reload();
  };

  /* ---------- the checkout guard ----------
     Two buttons on purpose: blocking with no way past gets screenshotted, and "check out without
     it" is the honest exit. It is a NUDGE, not a lock — anyone can hit /checkout directly, and
     the real backstop is a minimum order value set in Shopify admin. */
  var bypass = false;

  function modal(need, name){
    var old = document.getElementById('dp-min-veil');
    if (old) old.parentNode.removeChild(old);

    var v = document.createElement('div');
    v.id = 'dp-min-veil';
    v.setAttribute('style','position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);' +
      'display:flex;align-items:center;justify-content:center;padding:20px;' +
      'font-family:Helvetica,"Helvetica Neue",Arial,sans-serif');

    var card = document.createElement('div');
    card.setAttribute('style','background:#fff;color:#111;max-width:360px;width:100%;padding:22px 20px;' +
      'border-radius:0;box-shadow:0 12px 40px rgba(0,0,0,.3);text-align:center;text-transform:uppercase');

    card.innerHTML =
      '<div style="font-family:\'Montserrat\',Helvetica,Arial,sans-serif;font-weight:900;' +
           'font-style:italic;font-size:19px;margin-bottom:8px;color:#ff0000">' +
        'hold up — you’re ' + esc(need) + ' off your free piece…</div>' +
      '<div style="font-size:13px;line-height:1.6;margin-bottom:18px">your free <b>' + esc(name) +
        '</b> comes with any order over <b>' + esc(minSpend()) + '</b>. you’re at <b>' +
        esc(typeof window.dpFormat === 'function' ? window.dpFormat(shortfall.have) : '') +
        '</b> right now.</div>' +
      '<button id="dp-min-keep" style="display:block;width:100%;padding:14px;border:0;background:#111;' +
        'color:#fff;font-weight:700;font-size:12px;letter-spacing:.06em;text-transform:uppercase;' +
        'cursor:pointer">Keep shopping</button>' +
      '<button id="dp-min-go" style="display:block;width:100%;padding:13px;margin-top:9px;' +
        'background:#fff;border:1px solid #e4e4e4;color:#6b6b6f;font-weight:700;font-size:11px;' +
        'letter-spacing:.05em;text-transform:uppercase;cursor:pointer">Check out without it</button>';

    v.appendChild(card);
    v.addEventListener('click', function(e){ if (e.target === v) v.remove(); });
    document.body.appendChild(v);

    card.querySelector('#dp-min-keep').addEventListener('click', function(){
      v.remove();
      var ov = document.getElementById('dp-overlay');
      if (ov) { ov.classList.remove('open'); document.documentElement.style.overflow=''; }
    });
    card.querySelector('#dp-min-go').addEventListener('click', async function(){
      v.remove();
      await window.dpRemoveGift();
      bypass = true;
      location.href = '/checkout';
    });
  }

  function isCheckout(el){
    if (!el || !el.closest) return null;
    return el.closest('[name="checkout"], button[name="checkout"], input[name="checkout"], ' +
                      'a[href*="/checkout"], .cart__checkout, [data-checkout]');
  }

  document.addEventListener('click', function(e){
    if (bypass) return;
    if (!isCheckout(e.target)) return;
    if (!cached) return;                       /* no free piece in the cart — nothing to protect */

    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    (async function(){
      await refresh();
      if (!cached || !shortfall || !shortfall.short){
        bypass = true;
        location.href = '/checkout';
        return;
      }
      var need = (typeof window.dpFormat === 'function') ? window.dpFormat(shortfall.need) : '';
      modal(need, partsOf(cached).name);
    })();
  }, true);

  /* 🔴 14 Sep 2026 — HOW MANY PIECES DO THEY ACTUALLY HAVE?
     This function used to ask only one question — is a free piece in the CART — and wrote
     "free ring / pick yours and it goes in your bag at £0" whenever the answer was no. It never
     looked at the balance. For weeks that was invisible, because every account opened with a
     welcome credit so the answer was always at least one.

     The welcome credit went this morning and the fault surfaced immediately: Charlie's account,
     zero orders and an empty ledger, was shown "YOUR REWARDS / FREE PIECE / pick yours…" on Home
     and a live "Choose your free piece" button on Rewards. Pressing it opened the picker, said
     "Adding…", added nothing, and only after closing the picker did a message admit there were no
     pieces. That is the worst possible order to tell someone.

     ⚠ UNKNOWN IS TREATED AS ZERO, DELIBERATELY. credits.js loads the balance asynchronously, so
     the first paint often runs before it is known. Assuming a piece and correcting later flashes a
     promise we cannot keep; assuming none and correcting later just fills something in. Never
     claim a piece that has not been confirmed. */
  function balanceNow(){
    try{
      var c = window.DP_CREDITS;
      if (!c || !c.ok) return 0;
      return Number(c.balance) || 0;
    }catch(e){ return 0; }
  }

  /* ---------- the home glimpse and the CTA labels ---------- */
  function portal(line){
    if (!document.getElementById('p-rewards') && !document.getElementById('p-home')) return;

    var parts = line ? partsOf(line) : null;
    var min   = minSpend();
    var noun  = (typeof window.dpRewardNoun === 'function') ? window.dpRewardNoun() : 'ring';
    var bal   = balanceNow();
    var stamp = (parts ? parts.label : '') + '|' + min + '|' + noun + '|' + bal;

    var root = document.documentElement;
    if (root.getAttribute('data-dp-portal') === stamp) return;

    var bits = {
      glabel:  document.querySelector('#p-home .glimpse .glabel'),
      ggift:   document.querySelector('#p-home .glimpse .ggift'),
      sub:     document.querySelector('#p-home .glimpse .redeemable'),
      homeBtn: document.querySelector('#p-home .glimpse .btn'),
      pickBtn: document.querySelector('#p-rewards .btn.hot.block'),
      title:   document.querySelector('#dp-pickerVeil .pickhead .pt')
    };
    var chosen = document.getElementById('dp-chosen');

    /* The picker CTA and the heading above it ("Your free ring", the drawer's own Liquid). Shown
       only when there is something to pick. The heading is found as the CTA's own previous
       element rather than by index — "Other ways to earn" is the other `.sec` in this panel and
       the order of the two has already changed once. */
    function offer(on){
      var cta = document.querySelector('#p-rewards .btn.hot.block');
      if (cta) cta.style.display = on ? '' : 'none';
      var head = cta && cta.previousElementSibling;
      if (head && head.tagName === 'H3') head.style.display = on ? '' : 'none';
      if (on && bits.ggift) bits.ggift.style.color = '';
    }

    for (var k in bits){
      var el = bits[k];
      if (el && !el.hasAttribute('data-dp0')) el.setAttribute('data-dp0', el.innerHTML);
    }

    write(function(){
      /* the home button NAVIGATES, so it always says where it goes. The choosing happens on the
         screen it opens — two buttons saying "choose" read as the same button twice. */
      if (bits.homeBtn) bits.homeBtn.textContent = 'View rewards';

      if (line){
        var name = esc(parts.name), opts = esc(parts.opts);
        if (bits.glabel)  bits.glabel.textContent = 'in your bag';
        if (bits.ggift)   bits.ggift.textContent  = parts.name;
        if (bits.sub)     bits.sub.innerHTML =
            (opts ? opts + ', ' : '') + 'yours free on this order over ' + esc(min) + '.';
        if (bits.pickBtn) bits.pickBtn.textContent = 'Change your pick';
        if (bits.title)   bits.title.textContent = 'Change your pick';
        if (chosen){
          chosen.style.display = 'flex';
          chosen.innerHTML =
            '<span><b>' + name + (opts ? ' · ' + opts : '') + '</b> · <b class="free">FREE</b></span>' +
            '<span class="change" onclick="dpRemoveGift()">Remove</span>';
        }
        /* a piece is in the bag, so "Change your pick" has to be reachable even if a previous
           paint hid the CTA at a zero balance */
        offer(true);
      } else if (bal >= 1){
        /* the drawer hardcodes "Unlocked. Pick yours below, added free to your next order over
           £25." — `unlock` is banned and the £25 is wrong in every market but the UK */
        if (bits.glabel)  bits.glabel.textContent = 'your rewards';
        if (bits.ggift)   bits.ggift.textContent  = 'free ' + noun;
        if (bits.sub)     bits.sub.textContent =
            'pick yours and it goes in your bag at £0, free on your next order over ' + min + '.';
        if (bits.pickBtn) bits.pickBtn.textContent = 'Choose your free ' + noun;
        if (bits.title)   bits.title.textContent = 'Choose your free ' + noun;
        if (chosen){ chosen.style.display = 'none'; chosen.innerHTML = ''; }
        offer(true);
      } else {
        /* NOTHING TO PICK. Say so once, on Home, and take the picker away entirely rather than
           leaving a red button that opens a screen ending in a refusal.

           ⚠ "PLACE AN ORDER TO UNLOCK A FREE PIECE" WAS ASKED FOR AND IS NOT USED. `unlock` is on
           the copy deck's never-list and on domno-voice's own, and it appears in none of the 772
           reviews — it is the single most machine-sounding word available for this. The meaning is
           kept and the word is dropped, which is the same call made when "redeem" was asked for.
           The glimpse is the drawer's own red 30px display type, so the empty state is set to ink:
           red is for something they HAVE. */
        if (bits.glabel)  bits.glabel.textContent = 'your rewards';
        if (bits.ggift){
          bits.ggift.textContent = 'no free pieces yet';
          bits.ggift.style.color = 'var(--ink)';
        }
        if (bits.sub)     bits.sub.textContent =
            'your first order puts one in here, and you spend it on your next one.';
        if (bits.title)   bits.title.textContent = 'Choose your free ' + noun;
        if (chosen){ chosen.style.display = 'none'; chosen.innerHTML = ''; }
        offer(false);
      }
      root.setAttribute('data-dp-portal', stamp);
    });
  }
  /* ---------- 16 Sep 2026 (Charlie) — the shortfall as a REAL line item property ----------
     .dp-short above is painted into the storefront cart by JS, so it dies at /checkout and never
     reaches the order email. Dom removed the old static `Minimum spend: £25` on 9 Sep because the
     amber nudge said it better — but that was also the only version that FOLLOWED the line to
     checkout. This puts it back, live this time.
     ⚠ IT MUST CLEAR WHEN THEY QUALIFY. A frozen "£21 more" on a £60 order's confirmation is
     worse than saying nothing.
     ⚠ cart/change.js REPLACES the whole properties object, so every _reward_* key is merged back
     in or the worker loses the variant it swaps on.
     ⚠ Behind its own flag and on dpCartQueue: a properties write changes the line key and fires
     another cart event, which unguarded is a loop. The second pass exits on want === have. */
  var NUDGE_KEY = 'Almost there';
  var syncing = false;

  function desiredNudge(){
    if (!shortfall || !shortfall.short) return null;
    var amt = (typeof window.dpFormat === 'function') ? window.dpFormat(shortfall.need) : '';
    return amt ? (amt + ' more and it\u2019s yours') : null;
  }

  async function syncNudge(line){
    if (syncing || !line) return;
    var want = desiredNudge();
    var have = (line.properties && line.properties[NUDGE_KEY]) || null;
    if (want === have) return;

    syncing = true;
    try{
      var props = {};
      for (var k in (line.properties || {})) props[k] = line.properties[k];
      if (want) props[NUDGE_KEY] = want; else delete props[NUDGE_KEY];

      await queue(function(){
        return fetch('/cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
        });
      });
    }catch(e){}
    syncing = false;
  }
  var busy = false, cached = null;
  async function refresh(){
    if (busy) return;
    busy = true;
    try{
      var cart = await (await fetch('/cart.js', { headers:{ 'Accept':'application/json' } })).json();
      var ls = rewardLines(cart);
      cached = ls.length ? ls[0] : null;
      shortfall = computeShortfall(cart);
      document.documentElement.removeAttribute('data-dp-portal');
      var stale = document.querySelectorAll('.cart-item.product-free-gift[data-dp-state]');
      for (var i=0;i<stale.length;i++) stale[i].removeAttribute('data-dp-state');
      if (cached){ forceOne(cached); paintLine(cached); syncNudge(cached); }
      portal(cached);
    }catch(e){}
    busy = false;
  }

  function watch(){
    try{
      new MutationObserver(function(){
        if (writing) return;
        if (cached && document.querySelector('.cart-item.product-free-gift')) paintLine(cached);
        portal(cached);
      }).observe(document.documentElement, { childList:true, subtree:true });
    }catch(e){}
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ refresh(); watch(); });
  } else { refresh(); watch(); }

  ['on:cart:change','on:cart:after-merge','on:line-item:change'].forEach(function(nm){
    document.addEventListener(nm, function(){ refresh(); });
  });

  window.dpGiftRepaint = refresh;
})();